<template>
    <el-dialog
      :title="modalTitle"
      :visible="visible"
      width="800px"
      center
      :close-on-click-modal="true"
      @close="close()"
      class="custom-dialog"
    >
  
    <el-card shadow="always">

      <!-- PALLET -->
      <div class="gridTemplate-five">
            <el-form-item :label="i18nValues['code']">
              <a
                style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                >{{ this.palletToTransfer.code }}
              </a>
            </el-form-item>

            <el-form-item label="Brand">
              <a v-if="this.palletToTransfer.product"
                style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                > {{ this.palletToTransfer.product.brand }}
              </a>
            </el-form-item>

            <el-form-item :label="i18nValues['numberOfLabel']">
              <a
                style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                > {{ this.palletToTransfer.label.id }}
              </a>
            </el-form-item>

            <el-form-item :label="i18nValues['batch']">
              <a
                style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                > {{ this.palletToTransfer.batch }}
              </a>
            </el-form-item>

            <el-form-item :label="i18nValues['bagsNumber']">
              <a
                style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                > {{ this.palletToTransfer.bagsNumber }}
              </a>
            </el-form-item>
        </div>
  
        <!-- FIELDSITE -->
        <div class="gridTemplate-five">
            <el-form-item :label="i18nValues['destinationFieldSite']" prop="fieldSite">
            <el-select
                v-model="palletTrx.fieldSiteDestination"
                value-key="id"
                :placeholder="i18nValues['fieldSite']"
                filterable
            >
                <el-option
                v-for="item in FieldSitesList"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                >
                </el-option>
            </el-select>
            </el-form-item>
        </div>

        <el-alert
          v-if="transferValidationAlert"
          type="warning"
          show-icon
          :closable="true"
          class="transfer-validation-alert"
          @close="transferValidationAlert = null"
        >
          <span>{{ transferValidationAlert }}</span>
        </el-alert>
        
    </el-card>
  
    <div>
      <div class="button-style-save">
        <el-button
          icon="fas fa-check"
          :loading="loading"
          size="small"
          class="btn-primary"
          @click="sendStock()"
        >
          {{ i18nValues["send"] }}
        </el-button>
      </div>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
      name: "StockTransferModal",
      created() {
          this.retrieveFieldSites();
          this.initializePalletToSave(); 
      },
  
      computed: {
          loading: get("pallet/loading"),
          globalFieldSite: get("globalFieldSite"),
      },
  
      props: ["modalTitle", "visible", "palletToTransfer"],
  
      data() {
          return {
              palletTrx: {
                  fieldSite: {},
                  pallet: {}
              },
              FieldSitesList: [],
              transferValidationAlert: null,
          };
      },
  
      watch: {
          visible(newVal) {
              if (newVal) {
                  this.transferValidationAlert = null;
                  this.initializePalletToSave(); 
              }
          },
          "palletTrx.fieldSiteDestination": {
              handler(val) {
                  if (val && val.id != null) {
                      this.transferValidationAlert = null;
                  }
              },
              deep: true,
          },
      },
  
      methods: {
          initializePalletToSave() {
              this.palletTrx = {
                  pallet: { ...this.palletToTransfer },
                  user: this.user.name,
                  fieldSiteOrigin: this.globalFieldSite	
              };
          },
  
          close() {
              this.transferValidationAlert = null;
              this.palletTrx = {
                  fieldSite: {},
                  pallet: {}
              };
              this.$emit("update:visible", false);
          },
  
          retrieveFieldSites() {
              this.$store.dispatch("fieldSite/retrieveFieldSites").then((res) => {
                  this.FieldSitesList = res;
              });
          },
  
          sendStock() {
              if (!this.palletTrx.fieldSiteDestination || this.palletTrx.fieldSiteDestination.id == null) {
                  this.transferValidationAlert =
                      this.i18nValues["selectDestinationFieldSite"] ||
                      this.i18nValues["selectDestinationFieldSite"] ||
                      "Seleccione una planta de destino.";
                  return;
              }
              if (
                  this.globalFieldSite &&
                  this.globalFieldSite.id != null &&
                  Number(this.palletTrx.fieldSiteDestination.id) === Number(this.globalFieldSite.id)
              ) {
                  this.transferValidationAlert =
                      this.i18nValues["palletTransferSameSite"] ||
                      "La planta de destino debe ser distinta a la de origen.";
                  return;
              }

              this.transferValidationAlert = null;
              this.$store.dispatch("pallet/sendStock", this.palletTrx).then((res) => {
                if (res.status == "OK") {
                  this.$notify.success({
                    title: this.i18nValues["succes"],
                    message: this.i18nValues["palletSend"],
                    position: "bottom-right",
                  });
                  this.$emit("update:Pallets");
                  this.$emit("update:visible", false);
                } else {
                  this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["palletSendError"],
                    position: "bottom-right",
                  });
                }
              });
          }
      },
  };
  </script>
  
  
  <style scoped>
  
  .custom-button {
    margin-top: 10px;
    padding: 7px 12px;
  }
  
  .silosStyle {
    margin-left: 20px; 
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
  
  .button-style-add {
    margin-left: 20px
  }
  
  .button-style-save {
      display: flex; 
      justify-content: flex-end; 
      margin-right: 15px;
      margin-top: 15px;
  }

  .transfer-validation-alert {
      margin-top: 14px;
  }
  
  
  .custom-dialog .el-dialog__header {
    background-color: #009d57 !important; 
    color: #009d57 !important; 
  }
  
  
  </style>
  